import { FC } from 'react';

import './powered_by.css'

const CLAIMR_URL = 'https://claimr.io';

export const PoweredBy: FC = () => {
    const handle_navigate = () => {
        window.open(CLAIMR_URL, '_blank');
    };

    return (
        <div className='powered-by'>
            <span>Powered by</span>
            <div className='link' onClick={handle_navigate}>
                ⚡ Claimr.io™
            </div>
        </div>
    );
};
